import { RequiringActionFeatureType } from '@paid-ui/enums/requiring-action';

export const requiringActionLabelMap = {
  'JOIN_CONTRACT': 'Join contract',
  'JOIN_JOIN_CONTRACT': 'Join contract',
  'UPDATE_CONTRACT': 'Resubmit contract',
  'REVIEW_CONTRACT': 'Review contract',
  'SIGN_CONTRACT': 'Sign contract',
  'SUBMIT_CLAIM_CONTRACT': 'Create claim',
  'SUBMIT_CLAIM': 'Submit claim',
  'SUBMIT_BACKGROUND_CHECK': 'Apply for Transaction Account',
  'PAY_CONTRACT_DEPOSIT': 'Pay contract deposit',
  'REVIEW_REFUND_REQUEST': 'Review refund request',
  'UPDATE_REFUND_REQUEST': 'Resubmit refund request',

  'REVIEW_TERMINATE_CONTRACT_REQUEST': 'Review termination request',
  'UPDATE_TERMINATE_CONTRACT_REQUEST': 'Resubmit termination request',

  'REVIEW_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'Review contracts access request',
  'REQUEST APPROVED_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'Linked contracts access accepted',
  'REQUEST REJECTED_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'Linked contracts access declined',

  'SUBMIT REPORT_CLAIM_ASSESSMENT_REQUEST': 'Submit assessment',
  'REVIEW REPORT_CLAIM_ASSESSMENT_REPORT': 'Review claim assessment report',

  'REVIEW_CLAIM': 'Review claim',
  'UPDATE_CLAIM': 'Resubmit claim',
  'SECURE_CLAIM': 'Escrow claim',
  'PAY_CLAIM': 'Pay claim',

  'REVIEW_VARIATION': 'Review variation',
  'UPDATE_VARIATION': 'Resubmit variation',

  'REVIEW_ADJUSTMENT': 'Review adjustment',
  'UPDATE_ADJUSTMENT': 'Resubmit adjustment',

  'SECURE_CONTRACT': 'Escrow funds',
  'REVIEW_SECURE_PAID_REQUEST': 'Review escrowed funds',
  'UPDATE_SECURE_PAID_REQUEST': 'Resubmit escrowed funds',
  'REVIEW_UNSECURE_PAID_REQUEST': 'Review withdraw request',
  'UPDATE_UNSECURE_PAID_REQUEST': 'Resubmit withdraw request',
  'REVIEW_EARLY_RELEASE_REQUEST': 'Review InstaPaid counter offer.',

  'REVIEW_REVIEW_CLAIM_DOCUMENTS': 'View claim documents',
  'REVIEW_MASTER_CONTRACT_PDF': 'Signed contract PDF updated',
  'REVIEW_ASSOCIATE_RECKONER_REQUEST': 'Assign held funds',

  'REVIEW_RETENTION_REQUEST': 'Review retention request',
};

export const requiringActionButtonTextMap = {
  'JOIN_CONTRACT': 'Join',
  'JOIN_JOIN_CONTRACT': 'Join',
  'UPDATE_CONTRACT': 'Resubmit',
  'REVIEW_CONTRACT': 'Review',
  'SIGN_CONTRACT': 'Sign',
  'SUBMIT_CLAIM_CONTRACT': 'Create claim',
  'SUBMIT_CLAIM': 'Submit',
  'SUBMIT_BACKGROUND_CHECK': 'Apply',
  'PAY_CONTRACT_DEPOSIT': 'Pay deposit',
  'REVIEW_REFUND_REQUEST': 'Review',
  'UPDATE_REFUND_REQUEST': 'Resubmit',

  'REVIEW_TERMINATE_CONTRACT_REQUEST': 'Review',
  'UPDATE_TERMINATE_CONTRACT_REQUEST': 'Resubmit',

  'REVIEW_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'Review',
  'REQUEST APPROVED_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'View contract',
  'REQUEST REJECTED_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'View contract',

  'SUBMIT REPORT_CLAIM_ASSESSMENT_REQUEST': 'Submit',
  'REVIEW REPORT_CLAIM_ASSESSMENT_REPORT': 'Review report',

  'REVIEW_CLAIM': 'Review',
  'UPDATE_CLAIM': 'Resubmit',
  'SECURE_CLAIM': 'Escrow',
  'PAY_CLAIM': 'Pay',

  'REVIEW_VARIATION': 'Review',
  'UPDATE_VARIATION': 'Resubmit',

  'REVIEW_ADJUSTMENT': 'Review',
  'UPDATE_ADJUSTMENT': 'Resubmit',

  'SECURE_CONTRACT': 'Escrow funds',
  'REVIEW_SECURE_PAID_REQUEST': 'Review',
  'UPDATE_SECURE_PAID_REQUEST': 'Resubmit',
  'REVIEW_UNSECURE_PAID_REQUEST': 'Review',
  'UPDATE_UNSECURE_PAID_REQUEST': 'Resubmit',
  'REVIEW_EARLY_RELEASE_REQUEST': 'Review offer',

  'REVIEW_REVIEW_CLAIM_DOCUMENTS': 'View',
  'REVIEW_MASTER_CONTRACT_PDF': 'View contract',
  'REVIEW_ASSOCIATE_RECKONER_REQUEST': 'Assign',

  'REVIEW_RETENTION_REQUEST': 'Review',
};

export const requiringActionSearchParamMap = {
  'JOIN_CONTRACT': 'complete-contract',
  'JOIN_JOIN_CONTRACT': 'complete-contract',
  'UPDATE_CONTRACT': 'amend-contract',
  'REVIEW_CONTRACT': 'review-contract',
  'SIGN_CONTRACT': 'sign-contract',
  'PAY_CONTRACT_DEPOSIT': 'account-details',
  'SUBMIT_CLAIM_CONTRACT': 'new-claim',
  'SUBMIT_CLAIM': 'new-claim',
  'SUBMIT_BACKGROUND_CHECK': 'apply-account',

  'REVIEW_REFUND_REQUEST': 'deposit-refund',
  'UPDATE_REFUND_REQUEST': 'deposit-refund',

  'REVIEW_TERMINATE_CONTRACT_REQUEST': 'terminate-contract',
  'UPDATE_TERMINATE_CONTRACT_REQUEST': 'terminate-contract',

  'REVIEW_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'access-linked-contracts',
  'REQUEST APPROVED_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'access-linked-contracts',
  'REQUEST REJECTED_ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST': 'access-linked-contracts',

  'SUBMIT REPORT_CLAIM_ASSESSMENT_REQUEST': 'claim-details',
  'REVIEW REPORT_CLAIM_ASSESSMENT_REPORT': 'claim-details',

  'REVIEW_CLAIM': 'review-claim',
  'UPDATE_CLAIM': 'amend-claim',
  'SECURE_CLAIM': 'secure-claim',
  'PAY_CLAIM': 'pay-claim',

  'NEW_VARIATION': 'new-variation',
  'REVIEW_VARIATION': 'review-variation',
  'UPDATE_VARIATION': 'amend-variation',

  'NEW_ADJUSTMENT': 'new-adjustment',
  'REVIEW_ADJUSTMENT': 'review-adjustment',
  'UPDATE_ADJUSTMENT': 'amend-adjustment',

  'REVIEW_SECURE_PAID_REQUEST': 'secure-paid',
  'UPDATE_SECURE_PAID_REQUEST': 'secure-paid',
  'REVIEW_UNSECURE_PAID_REQUEST': 'unsecure-paid',
  'UPDATE_UNSECURE_PAID_REQUEST': 'unsecure-paid',
  'SECURE_CONTRACT': 'secure-contract',
  'REVIEW_EARLY_RELEASE_REQUEST': 'earlyrelease-review-offer',

  'REVIEW_REVIEW_CLAIM_DOCUMENTS': 'claim-details',
  'REVIEW_MASTER_CONTRACT_PDF': 'contract-details',
  'REVIEW_ASSOCIATE_RECKONER_REQUEST': 'assign-funds',

  'REVIEW_RETENTION_REQUEST': 'review-retention-return',
};

export const contractRequiringActionSet = new Set([
  RequiringActionFeatureType.CONTRACT,
  RequiringActionFeatureType.CONTRACT_DEPOSIT,
  RequiringActionFeatureType.REFUND_REQUEST,
  RequiringActionFeatureType.SECURE_PAID_REQUEST,
  RequiringActionFeatureType.UNSECURE_PAID_REQUEST,
  RequiringActionFeatureType.TERMINATE_CONTRACT_REQUEST,
  RequiringActionFeatureType.ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST,
  RequiringActionFeatureType.CLAIM_ASSESSMENT_REQUEST,
  RequiringActionFeatureType.CLAIM_ASSESSMENT_REPORT,
  RequiringActionFeatureType.RETENTION_REQUEST,
]);
